import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/parameter.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { ParameterEffects } from './state/parameter.effects';

import { ParameterShellComponent } from './containers/parameter-shell/parameter-shell.component';
import { ParameterListComponent } from './components/parameter-list/parameter-list.component';

// Módulo con elementos compartidos (service, directive, pipes, components, etc.).
import { SharingModule } from '../sharingModule/sharingModule.module';


@NgModule({
  declarations: [
    ParameterShellComponent,
    ParameterListComponent
  ],
  imports: [
    SharingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('parameters', reducer),
    EffectsModule.forFeature([ParameterEffects])
  ],
  exports: [
    ParameterListComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class ParameterModule {
  constructor(
  ) {}

}
